import { Injectable } from '@angular/core'
import { Resolve } from '@angular/router'
import { getMenuItems, getRoles, getTicket } from '@app/modules/shares/utils/functions/common'
import { PermissionService } from 'projects/vss-ui/src/public-api'
import { Observable, of } from 'rxjs'


@Injectable({
  providedIn: 'root'
})
export class UserResolver implements Resolve<Observable<any>> {
  constructor(
    private permission: PermissionService
  ) {

  }

  resolve(): Observable<any> {
    const menuItems = getMenuItems()
    const useRole = getRoles()

    if (!useRole) return of(false)

    this.permission.setRuleUser([
      ...useRole
    ])

    this.permission.setMenu(menuItems)
    return of(true)

  }

  checkChildren(data: any) {
    if (data?.length) {
      return data.map((x: any) => ({ ...x, title: x?.menuName, children: this.checkChildren(x?.menuDtos ? x?.menuDtos : x?.children) }))
    } else {
      return []
    }
  }
}
